/* eslint-disable max-len */
module.exports = {
  'Internal Server Error': 'Internal Server Error',
  // 网络相关错误
  networkError: '网络不通，请检查网络和代理配置',
  UNABLE_TO_VERIFY_LEAF_SIGNATURE:
    'HTTPS 证书错误，请确认是否使用了抓包工具或代理工具，可尝试关闭“校验 HTTPS 证书”选项，全局代理变更后，需要重启客户端',
  SELF_SIGNED_CERT_IN_CHAIN:
    'HTTPS 证书错误，请确认是否使用了抓包工具或代理工具，可尝试关闭“校验 HTTPS 证书”选项，全局代理变更后，需要重启客户端',
  ENOSPC: '磁盘空间不足',
  EPERM: '没有本地目录权限',
  ETIMEDOUT: '请求超时',
  ECONNRESET: 'ECONNRESET 网络错误',
  ENOTFOUND: 'ENOTFOUND 域名解析出错，请检查网络',
  failed_to_set_tags: '设置标签失败，网络开了个小差',

  // COS 相关错误
  'AuthFailure.UnauthorizedOperation': '请求无 CAM 授权',
  'UnauthorizedOperation.CdnCamUnauthorized': '权限不足，请联系根账号赋予 [cdn:* 或 cdn:DescribeDomains] 权限',
  TagUnauthorizedTitle: '无法按标签检索存储桶',
  TagUnauthorized: '权限不足，请联系根账号赋予 [tag:* 或 tag:DescribeResourcesByTags] 权限',
  AccessDenied: '没有权限',
  'Unavailable For Legal Reasons': '存储桶已被封禁，请提交工单确认原因并申请解封',
  'Unable to send AtomFrameHostMsg_Message_Sync': '客户端异常退出',
  BUCKET_APPID_ERROR: '没有权限添加该访问路径',
  OWNER_HAS_NO_AUTH_ADD_ACCESS_PATH: '主账号没有权限添加该访问路径',
  PARAM_IS_INVALID: '参数错误',
  BucketAlreadyExists: '存储桶名称已存在，请重新输入',
  NoSuchBucket: '指定的存储桶不存在',
  NoSuchKey: '源文件不存在',
  BadDigest: '文件内容校验错误',
  NoSuchUpload: '没有这个上传文件',
  ENOENT: '没有这个文件/目录',
  InvalidDigest: '您指​​定的Content-MD5无效',
  OAZOperationNotSupportOnMAZBucket: '权限不足，请联系主账号 Owner 授予 HeadBucket 权限',
  UnavailableForLegalReasons: '该账号尚未实名或已被封禁',
  up_to_10_tags_are_allowed: '标签数量最多为 10',
  InvalidTag: '标签含有无效字符',
  RestoreAlreadyInProgress: '该对象正在回热（恢复）中',
  RestoreFileSizeExceed: '超过 256MB 的对象不能使用极速模式（Expedited）恢复',
  RestoreNonArchiveObject: '不允许对非归档对象进行回热（恢复）',
  'InvalidParameter.GrantOtherResource': '越权访问资源',

  unknownError: '未知错误',
  requestError: '请求错误',
  bucketListEmpty: '没有可访问的存储桶',
  secretError: 'SecretId、SecretKey 填写错误',
  signatureError: '签名不匹配，请检查密钥等信息是否准确',
  secretIdError: 'SecretId 填写错误',
  bucketNameError: '存储桶名称错误',
  projectSecretWarning: '项目密钥不适用于当前客户端',
  machineTimeTooSkewed: '本地机器时间偏差太大，请校正时间后重启客户端',
  httpsCertificateError: 'HTTPS 证书错误，请确认是否使用了抓包工具或代理工具，可尝试关闭“校验 HTTPS 证书”选项',
  needAccessPathOrGetServiceAccess: '请通过访问路径进行登录，或主帐号赋予 QcloudCOSGetServiceAccess 权限',
  needAccessPath: '请通过访问路径进行登录',
  orGetServiceAccess: '或主帐号赋予 QcloudCOSGetServiceAccess 权限',
  malformed_proxy: '代理格式错误',

  // 没有权限
  no_permission_to_cloud_monitoring_simple: '您没有访问云监控数据的权限',
  no_permission_to_cloud_monitoring:
    '您没有访问云监控数据的权限，请联系根账号赋予 HeadBucket 和 [monitor:* 或 monitor:GetMonitorData] 权限',
  no_permission_to_edit_storage_class:
    '您没有编辑存储类型的权限，请联系根账号赋予 GetObjectAcl、PutObjectAcl 和 PutObjectCopy 权限',
  no_permissions_to_download: '没有下载权限',
  no_permissions_to_upload: '没有上传权限',
  no_permissions_to_list_files: '请确认是否有要下载的对象列表的访问权限',
  no_permissions_to_list_object_versions: '对不起，您没有列出多版本文件列表的权限，请联系主帐号授权',
  no_permissions_to_get_bucket: '对不起，您没有列出存储桶文件列表的权限，请联系主帐号授权',
  no_permissions_to_delete_object: '删除失败，请检查是否拥有删除文件的权限',
  no_permissions_to_get_bucket_acl: '对不起，您没有权限读取存储桶的访问权限',
  no_permissions_to_access_bucket_acl: '没有存储桶访问权限的设置权限，请联系主帐号授权。',
  no_permissions_to_access_bucket_incomplete_uploads: '对不起，您没有权限读取存储桶未完成上传的列表',
  no_permissions_to_list_multipart_uploads: '删除失败，请检查是否拥有查询文件碎片的权限',
  no_permissions_to_delete_multipart_uploads: '删除失败，请检查是否拥有删除文件碎片的权限',
  no_permissions_to_get_versioning: '对不起，您没有获取版本控制信息的权限',
  no_permissions_to_get_acceleration: '对不起，您没有获取全球加速配置的权限',
  no_permissions_to_create_bucket: '对不起，您没有创建存储桶的权限',
  no_permissions_to_delete_bucket: '对不起，您没有该存储桶的删除权限',
  no_permissions_to_bucket_versioning_configuration:
    '您没有权限读取存储桶的版本控制配置，请联系根账号赋予 GetBucketVersioning 或完全控制权限',
  no_permissions_to_update: '更新失败：Could not create temporary directory: 权限被拒绝',
  no_permissions_to_head_object: '对不起，您没有读文件元数据的权限，请联系主账号授权',
  no_permissions_to_get_object_acl: '对不起，您没有读文件ACL的权限，请联系主账号授权',
  no_permissions_to_slice_copy_file: '对不起，您没有写文件的权限，请联系主账号授权',
  no_permissions_to_copy_file: '对不起，您没有复制的权限，请联系主账号授权',
  no_permissions_to_get_bucket_tagging: '对不起，您没有权限读取存储桶的标签管理配置',
  no_permissions_to_get_object_tagging: '对不起，您没有权限读取对象的标签管理配置',
  no_permissions_to_put_tagging: '对不起，您没有权限设置标签，请联系主帐号授权',
  no_permissions_to_delete_tagging: '对不起，您没有权限删除标签，请联系主帐号授权',
  no_permissions_to_put_bucket_cors: '对不起，您没有权限配置存储桶跨域，请联系根账号赋予  PutBucketCors 权限',
  no_permissions_to_get_sts:
    '对不起，您没有权限获取联合身份临时访问凭证，请联系根账号赋予 [sts:GetFederationToken] 权限',
  no_permissions_to_put_bucket_versioning: '无权限设置该存储桶的版本控制配置，请联系主账号授权',
  no_permissions_to_get_bucket_website: '对不起，您没有权限读取存储桶的静态网站配置，请联系主账号授权',
  no_permissions_to_put_bucket_website: '对不起，您没有权限设置该存储桶的静态网站配置，请联系主账号授权',

  // 客户端自定义错误
  file_already_exist: '本地文件已存在',
  exist_same_file: '已存在同名文件，无法创建目录：',
  exist_same_dir: '已存在同名目录，无法创建文件：',
  exist_same_filename_in_target_location: '目标位置存在同名文件，请重新编辑!',
  remote_folder_exist: '已存在同名文件夹',
  remote_file_not_found: '线上文件已被删除',
  local_file_not_found: '本地文件已被删除',
  remote_file_has_changed: '线上文件已被修改',
  local_file_has_changed: '本地文件已被修改',
  archive_file_not_support_download: '归档文件不支持下载',
  archive_file_not_support_preview: '未恢复的归档文件不支持预览',
  unknown_chunk_size: '获取分块大小失败',
  download_file_err: '文件下载出错',
  bucket_not_selected: '没选中存储桶',
  render_menu_list_err: [
    'SecretId、SecretKey 错误', // 0
    '没有 QcloudCOSGetServiceAccess 权限', // 1
    '没有可访问的存储桶', // 2
  ],
  render_bucket_list_err: [
    '存储桶列表获取错误', // 0
    '当前 SecretId 没有可访问的存储桶或访问路径', // 1
  ],
  thumbnail_image_too_large: '部分图片大于 20MB，不显示缩略图',
  edit_file_too_large: '文件大于 {num} MB，不支持编辑',
  open_file_too_large: '{files} 文件大于 20MB 不支持快捷打开，请下载后打开',
  not_support_to_preview: '该文件类型不支持预览',
  not_support_view_detail: '不支持查看详情',
  preview_err: '预览出错',
  parse_image_fail: '解析图片失败',
  no_exif_data: '图片无exif信息',
  get_download_list_err: '下载列表获取失败',
  not_selected_local_folder: '未选中本地文件夹',
  empty_clipboard: '粘贴板为空',
  empty_authorized_user: '授权用户账号 ID 不能为空',
  no_filename_available_to_paste: '粘贴找不到可用的文件名',
  no_file_to_paste: '没有可粘贴的文件',
  no_file_to_delete: '没有要删除的文件',
  no_file_to_upload: '没有需要上传的文件',
  no_file_to_download: '没有需要下载的文件',
  not_support_to_drop_here: '不支持拖放到此处',
  choose_file_to_rename: '请选择要重命名的文件',
  choose_at_least_one_user_acl: '请选择至少一个用户权限',
  not_support_multi_to_rename: '重命名暂不支持多选',
  not_support_to_rename_folder: '重命名暂不支持文件夹',
  del_valid_files_before_del_bucket: '删除失败，请检查存储桶是否已清空（文件、历史版本、上传碎片）',
  local_file_not_exist: '本地文件已删除',
  remote_file_not_exist: '存储桶文件已删除',
  remote_folder_not_exist: '存储桶文件夹已删除',
  failed_to_add_access_path: '收藏路径添加失败',
  failed_to_delete_access_path: '收藏路径删除失败',
  failed_to_create_bucket: '存储桶创建失败',
  failed_to_delete_bucket: '存储桶删除失败',
  failed_to_set_policy_of_1000: '设置访问权限失败，策略数量已达上限1000条',
  failed_to_access_permission_of_no_such_account: '设置访问权限失败，请检查已有的权限列表中是否有不存在的子账号',
  get_file_size_err: '文件大小获取失败',
  get_file_etag_err: '文件Etag获取失败',
  part_size_not_match: '分片大小不匹配',
  bulk_interface_delete_err: '批量接口删除失败',
  part_files_delete_failed: '部分文件删除失败',
  too_much_files: '文件不能超过 100 万个',
  invalid_url: 'URL 不合法',
  set_v4_acl_fail: 'COS V4 ACL 权限设置失败.',
  archived_file_not_allow_change: '归档存储不允许修改',
  showkey_not_found: '在已拉取的文件中未找到该文件，可通过搜索进行定位。',
  get_cdn_host_faild: 'CDN 域名获取失败',
  edit_acl_failed_of_cdn_host_exist: '该存储桶存在 CDN 加速域名/自定义域名，请到控制台编辑存储桶的 ACL 权限',
  delete_bucket_failed_of_cdn_host_exist: '删除存储桶失败。请关闭存储桶中的 CDN 加速域名以及删除自定义域名',
  unable_to_get_user_information: '无法获取到用户信息。',
  failed_to_get_versioning: '获取版本控制配置信息失败',
  failed_to_get_acceleration: '获取全球加速配置信息失败',
  no_incomplete_upload: '您没有未完成的上传',
  failed_to_get_incomplete_uploads: '获取未完成文件列表失败',
  no_such_incomplete_upload: '该分块上传任务已经完成或被取消',
  no_versioning_to_clear: '该目录下的历史版本文件已被清空。',
  bucket_not_enable_versioning: '目标存储桶未开启版本控制。',
  with_dirty_data: '有脏数据残留',
  choose_one_session: '请选中一个会话下的访问路径进行登录',
  session_exist: '该会话已存在',
  quick_access_path_exist: '该快速访问路径已存在',
  sub_account_not_exist: '子账号 {subUin} 不存在，请检查是否存在对应的子账号',
  exist_same_account_user_acl: '已存在账号 ID {uin} 对应的用户权限',
  params_duplicate_add: '{params} 重复添加',
  region_unreachable_between_fsi_public: '金融地域和公有云地域网络不互通',
  no_support_copy_MAZ_OAZ: '多AZ存储桶和单AZ存储桶间不支持复制操作',
  no_support_between_parent_dir_and_sub: '父目录不允许复制到子目录下',
  not_allow_paste_in_origin: '不允许在原位置粘贴',
  file_consistency_check_error: '一致性校验错误',
  file_consistency_check_error_param: '{count} 个文件一致性校验错误',
  up_to_1000_policy: '该账户下拥有的策略数达到1000条上限',
  policies_reach_200: '用户/用户组/角色绑定的策略数达到200条上限',
  failed_to_copy_of_network: '复制失败，网络开了个小差',
  tag_cannot_be_empty: '标签不可为空',
  the_entered_tag_character_is_invalid: '输入的标签字符不合法',
  modified_file_need_save: '文件已修改，请另存后，再重新打开该文件。',
  not_support_save_as_encode_param: '编辑内容中存在不支持保存为 {encode} 编码的字符。',
  content_exist_garbled: '编辑内容中可能存在乱码。',
  not_allowed_edit: '在线编辑只支持文本文件，该文件格式不支持编辑。',
  no_need_to_switch_account: '已在该会话中，无需切换。',
  not_allow_rename_with_slash: '文件名不可带斜杠 “/”',
  InvalidObjectState: '当前对象的存储类型无法进行该操作',
  curr_bucket_not_belongs_to_you: '当前存储桶不属于你的主账号',
  loading_file_acl_timeout: '查询文件权限超时。',
  linked_file_does_not_exist: '链接文件不存在',
  not_allow_restore_file_open: '该文件为归档存储不可打开',
  delete_replication_before_suspend_versioning: '暂停前请删除当前存储桶全部跨地域复制规则',
  curr_region_not_support_operator: '当前地域暂不支持，建议使用控制台 / COSBrowser 客户端进行操作',
  curr_region_not_support_rw_Share: '当前地域暂不支持设置读写权限。',

  // 调用 SCF 函数返回的自定义错误
  'SCF.Timeout': '导入超时，请重试',
  'Downloader.TooLarge': '资源超过 50M，无法导入',
  'Downloader.WriteStreamError': '资源导入失败',
  'Downloader.HttpRequestError': '请求的资源无法进行导入',
  'Downloader.UrlNotFound': '您提供的资源链接不存在，无法导入',
  'ZipExtractor.GetEntriesError': '资源导入失败',
  'Traverse.GetFilesError': '资源导入失败',
  RequestError: '网络繁忙，请稍后重试',

  ofs_image_slim_unsupport: 'OFS元数据加速桶暂不支持图片极智压缩',
  region_image_slim_unsupport: '当前地域不支持极智压缩',
  get_access_denied: '无查询权限',
  ups_app_not_exist: '未开通数据万象，请先绑定数据万象',
  ups_app_not_exist_html: '未开通数据万象，请先 <a href="https://console.cloud.tencent.com/ci" target="_blank">绑定数据万象</a>',
};
